import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { publicFetchBlob } from "@/lib/shareApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PdfViewer = ({ fileId, fileName, serveUrl }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;
    setLoading(true);
    setError(null);
    setBlobUrl(null);

    const loadPdf = async () => {
      try {
        const blob = serveUrl
          ? await publicFetchBlob(serveUrl)
          : (await axios.get(`${API}/files/${fileId}/serve`, { responseType: "blob" })).data;
        if (cancelled) return;
        objectUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
        setBlobUrl(objectUrl);
      } catch {
        if (!cancelled) setError("Failed to load PDF");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    loadPdf();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileId, serveUrl]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full min-h-[40vh] bg-[var(--xl-bg)] rounded-lg">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (error || !blobUrl) {
    return (
      <div className="flex items-center justify-center h-full min-h-[40vh] bg-[var(--xl-bg)] rounded-lg text-sm text-muted-foreground">
        {error ?? "PDF unavailable"}
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full min-h-[40vh] rounded-lg overflow-hidden border border-[var(--xl-line)]" data-testid="pdf-viewer">
      {fileName && (
        <div className="px-3 py-2 text-xs text-muted-foreground border-b border-[var(--xl-line)] bg-[var(--xl-surf)] truncate">
          {fileName}
        </div>
      )}
      <iframe
        title={fileName || "PDF viewer"}
        src={blobUrl}
        className="flex-1 w-full min-h-[50vh] bg-white"
      />
    </div>
  );
};

export default PdfViewer;
